import { instance } from "..";

export const getGameByCode = async (code) => {
  const response = await instance.get(`/api/web/${code}`);
  return response.data;
};

export const questionShown = async (questionId, isAnswered) => {
  const response = await instance.put(`/api/web/question/shown/${questionId}`, {
    isAnswered,
  });
  return response.data;
};

export const getTopWinners = async () => {
  const response = await instance.get("/api/web/winners/top");
  return response.data;
};

// Turn an owned game into a playable web session. Returns { codeInfo: { code } }.
export const createWebGame = async (gameId) => {
  const { data } = await instance.post(`/api/web/create/${gameId}`);
  return data;
};

// --- Authenticated game management (pro backend, JWT via interceptor) ---

export const getMyGames = async () => {
  const { data } = await instance.get("/api/game/my-games/");
  return data;
};

export const getGame = async (id) => {
  const { data } = await instance.get(`/api/game/${id}`);
  return data;
};

export const getGameForEdit = async (id) => {
  const { data } = await instance.get(`/api/game/edit/${id}`);
  return data;
};

// gameData = { gameName, modes:[id], customModes:[id], teams:[{name, image:teamImageId}],
//   playedQuestions, fadedQuestions, lowToHighPoints, from246PointsSystem, from135PointsSystem }
export const createGame = async (gameData) => {
  const { data } = await instance.post("/api/game/create", gameData);
  return data;
};

export const updateGame = async (id, gameData) => {
  const { data } = await instance.put(`/api/game/${id}`, gameData);
  return data;
};

export const deleteGame = async (id) => {
  const { data } = await instance.delete(`/api/game/${id}`);
  return data;
};

export const getTeamImages = async () => {
  const { data } = await instance.get("/api/team/team-images");
  return data;
};
